import { useMemo } from 'react';
import FacetWrapper from './FacetWrapper';
import { FilterBase } from '../../interfaces';
import { hashCode } from '../../utils';
import { useAppSelector } from '../../app/hooks';
import { selectedFilters, resultFilters } from '../../features/filter/filterSlice';

import { resultFilterPreparation, cushioningReactionPreparation } from './utils';
import { FilterValueName } from '../../features/filter/interfaces';
import useTranslation from '../../features/translation/hooks/useTranslation';

interface ResultsProps {
  onChange: (filterName: string, value: (string | number)[] | string | number) => void;
}

export default function ResultsFilter({ onChange }: ResultsProps): JSX.Element {
  const storedFilters = useAppSelector(selectedFilters);
  const filters = useAppSelector(resultFilters);
  const t = useTranslation();

  const uniqueFilters = useMemo(() => {
    const seen = new Set<string>();
    return filters.filter((f) => {
      if (seen.has(f.key)) return false;
      seen.add(f.key);
      return true;
    });
  }, [filters]);

  return (
    <>
      {uniqueFilters.length > 0 &&
        uniqueFilters.map((filter) => {
          const filterIndex = filter.key as FilterValueName;
          let storedValue = storedFilters[filterIndex];
          if (filter.key === 'additionalFunction') {
            storedValue = storedFilters['forBatteryProduction'];
          }

          // Preparing and updating filter with redux data
          let updatedFilter = resultFilterPreparation(filter, storedValue, t);

          // Special case, Cushioning Reaction
          let storedSoftValue: boolean | null = false;
          let storedRobustValue: boolean | null = false;
          if (filter.key === 'cushioningReaction') {
            storedSoftValue = storedFilters['soft'];
            storedRobustValue = storedFilters['robust'];

            updatedFilter = cushioningReactionPreparation({
              filter: filter,
              storedRobustValue: storedRobustValue,
              storedSoftValue: storedSoftValue,
              t,
            });
          }

          return (
            <FacetWrapper
              filter={updatedFilter as FilterBase}
              key={hashCode(`${filter.id}`.toString())}
              root
              visible
              onChange={(filterName, newValue): void => onChange(filterName, newValue)}
              id={hashCode(`${filter.id}`.toString())}
            />
          );
        })}
    </>
  );
}
